module.exports = "/_next/static/images/oops-b10da8ab8ef5249cbfbd002c2961e079.svg";